/**
 *
 * Details Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

const selectService = (state) => state ? state[NAMESPACE] : {};

const selectStatus = createSelector(selectService, (service) => service.status);

const selectTransferId = createSelector(selectService, (service) => service.transferId);

const selectResult = createSelector(selectService, (service) => service.result);

const selectError = createSelector(selectService, (service) => service.error);

const selectHasActionResolvableByCurrentUser = createSelector(selectResult, (result) =>
  Boolean(result && result.prescribedActions.some((action) => action.isResolvableByCurrentUser)));

export {
  selectStatus,
  selectTransferId,
  selectResult,
  selectError,
  selectHasActionResolvableByCurrentUser,
};



// WEBPACK FOOTER //
// ./src/services/details/selectors.js